export default function Google() {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' fill='none' viewBox='0 0 24 24'>
            <g fill-rule='evenodd' clipPath='url(#a)' clipRule='evenodd'>
                <path
                    fill='#4285f4'
                    d='M23.9 12.27q0-1.28-.22-2.45h-11.3v4.64h6.45a5.5 5.5 0 0 1-2.4 3.62v3.01h3.89c2.27-2.09 3.57-5.16 3.57-8.82'
                />
                <path
                    fill='#34a853'
                    d='M12.38 24c3.23 0 5.95-1.07 7.94-2.9l-3.88-3.02a7 7 0 0 1-4.07 1.15 7.15 7.15 0 0 1-6.71-4.95h-4v3.1A12 12 0 0 0 12.37 24'
                />
                <path fill='#fbbc05' d='M5.66 14.28a7.2 7.2 0 0 1 0-4.56v-3.1h-4a12 12 0 0 0 0 10.77z' />
                <path
                    fill='#ea4335'
                    d='M12.38 4.77c1.76 0 3.34.6 4.58 1.8l3.44-3.44A11.5 11.5 0 0 0 12.38 0 12 12 0 0 0 1.64 6.61l4.01 3.11a7.15 7.15 0 0 1 6.72-4.95'
                />
            </g>
            <defs>
                <clipPath id='a'>
                    <path fill='#fff' d='M0 0h24v24H0z' />
                </clipPath>
            </defs>
        </svg>
    );
}
